import { addDoubleQuotes } from '../utils/smartutils';

export function itensTabletActiveListByNivel() {
  const query = `{
    itensTabletActiveListByNivel(level:1, father:0)
    {id, name, shortName, description, order, active, addOn, sendTimeline, level, fatherCode, program{id}, typeOfMeal{id, name}, 
    iconTablet{id, link}, iconTimeline{id, link}, multiple, itemValue, finalItem,  foodItem, needsApproval, approverProfile{id, name},
    titleTimeline, timelineTime, requestTime, requestTimeType, calculatePeriod, formItem, notConform, label, value
    }
}`;

  return query;
}
export function itensTabletActiveListByFather(level, fatherId) {
  const query = `{itensTabletActiveListByNivel(level:${level}, father:${fatherId})
    {id,
     name,
     shortName,
     description,
     order,
     active,
     addOn,
     sendTimeline,
     level,
     fatherCode,
     program{id},
     typeOfMeal{id, name}, 
     iconTablet{id, link},
     iconTimeline{id, link},
     multiple, itemValue, finalItem,  foodItem, needsApproval, approverProfile{id, name},
    titleTimeline, timelineTime, requestTime, requestTimeType, calculatePeriod, formItem, notConform}}`;

  return query;
}

export function relationStudentClasses(classes) {
  const query = `{relationStudentClasses(classesId:[${classes || 0}])
    {student{id, fullName}}}`;

  return query;
}

export function relationStudentClassesByFilter(filter) {
  const query = `{relationStudentClassesByFilter(filter: ${JSON.stringify(
    filter
  ).replace(/"([^(")"]+)":/g, '$1:')})
    {student{id, fullName}}}`;
  return query;
}

export function employeeListByFilter() {
  const query = `{
    employeeListByFilter(
      filter: {
        id: 0
        usuarioChatInterno: false
        ativo: false
        filterByStatus: false
        pedagogicAdm: false
        updaterId: 0
        usuarioChat: false
        active: true
      }
    ) {
      id
      name
    }
  }
  `;

  return query;
}

export function noteByFilterForGrid(filter) {
  let itensId;
  let classesId;
  let studentsId;
  let employeesId;
  if (filter.itens) {
    itensId = filter.itens.map((itens) => itens.id);
  }

  if (filter.classes) {
    classesId = filter.classes.map((classes) => classes.id);
  }

  if (filter.students) {
    studentsId = filter.students.map((students) => students.id);
  }

  if (filter.employees) {
    employeesId = filter.employees.map((employees) => employees.id);
  }
  const query = `{noteByFilterForGrid(filter:{initialDate:${filter.initialDate.getTime()}, finalDate: ${filter.finalDate.getTime()}, status: ${
    addDoubleQuotes(filter.status) || null
  }, itens:[${itensId || []}], classes:[${classesId || []}], students:[${
    studentsId || []
  }], employees:[${employeesId || []}], normalSinc:${
    filter.normalSinc
  }, regularSinc:${filter.regularSinc}, badSinc:${
    filter.badSinc
  }}){id, studentName, levelOne, note, dateNote, hourNote, noteComplement, responsible, status, employee, dateSinc, source, statusSinc, readingInformation }}
`;
  return query;
}

export function saveNotes(values) {
  const { responsible } = values;
  const responsiveId = responsible && responsible.value ? responsible.value : 0;
  let updatedItems;
  if (!values.notes) {
    updatedItems = values.appoitmentStudent.map((items) => ({
      id: 0,
      idResponsible: responsiveId,
      idenItem: null,
      idStudent: items.student.id,
      dateNote: items.dateNote ? new Date(items.dateNote).getTime() : null,
      hourNote: items.hourNote,
      idItemNote: values.selectedItems[values.selectedItems.length - 1].id,
      noteComplement: items.noteComplement,
      program: items.program,
      firstLevelItemCode: items.firstLevelItemCode,
      valueNote:
        values.selectedItems[values.selectedItems.length - 1].valueNote,
      typeOfMeal:
        values.selectedItems[values.selectedItems.length - 1].typeOfMeal,
      createEmployeeId: 0,
    }));
  } else {
    updatedItems = values.notes.map((items) => ({
      id: 0,
      idResponsible: responsiveId,
      idStudent: items.student.id,
      idenItem: null,
      dateNote: items.dateNote ? items.dateNote.getTime() : null,
      hourNote: items.hourNote,
      idItemNote: items.idItemNote
        ? items.idItemNote
        : values.selectedItems[values.selectedItems.length - 1].id,
      noteComplement: items.noteComplement,
      program: items.program,
      firstLevelItemCode: items.firstLevelItemCode,
      valueNote: items.valueNote
        ? items.valueNote
        : values.selectedItems[values.selectedItems.length - 1].valueNote,
      typeOfMeal: items.typeOfMeal
        ? items.typeOfMeal
        : values.selectedItems[values.selectedItems.length - 1].typeOfMeal,
      createEmployeeId: 0,
    }));
  }

  const mutationQuery = `mutation{
          saveNotes(notes:${JSON.stringify(updatedItems).replace(
            /"([^(")"]+)":/g,
            '$1:'
          )})
          {id}
      }`;
  return mutationQuery;
}

export function saveEditNote(values) {
  const { responsible } = values;
  const idResponsible =
    responsible && responsible.value ? responsible.value : 0;
  const updatedValues = values.map((item) => ({
    ...item,
    idResponsible,
    createEmployeeId: 0,
  }));
  const mutationQuery = `mutation{
          saveNotes(notes:${JSON.stringify(updatedValues).replace(
            /"([^(")"]+)":/g,
            '$1:'
          )})
          {id}
      }`;
  return mutationQuery;
}

export function noteById(id) {
  return `{
  noteById(id: ${id}) {
    id
    idResponsible
    idStudent
    dateNote
    hourNote
    idItemNote
    noteComplement
    program {
      id
    }
    firstLevelItemCode
    typeOfMeal {
      id
      name
    }
    valueNote
    class {
      id
      name
    }
    student {
      id
    }
    createEmployeeId
    responsible {
      id
      fullName
    }
  }
}`;
}

export function noteByIds(ids) {
  const query = `{noteByIds(ids:[${ids}])
    {id, student{id}, dateNote, hourNote, idItemNote, noteComplement, program{id}, firstLevelItemCode, typeOfMeal{id, name}, valueNote, class{id, name}, createEmployeeId,  descriptionItem, nameItem, linkIconItem}
}`;
  return query;
}

export function itensTabletByBrother(id) {
  const query = `{itensTabletByBrother(id:${id})
    {id, name, value, label, itemValue, shortName}
}`;

  return query;
}

export function deleteNotes(id) {
  const mutationQuery = `mutation{
    deleteNotes(idsNotes:[${id}])
}`;

  return mutationQuery;
}

export function approveNoteByIds(idsToApprove) {
  return ` 
  mutation { approveNoteByIds(ids: ${JSON.stringify(idsToApprove).replace(
    /"([^(")"]+)":/g,
    '$1:'
  )})
  }`;
}

export function disApproveNoteByIds(idsToDisapprove) {
  return ` 
  mutation { disApproveNoteByIds(ids: ${JSON.stringify(idsToDisapprove).replace(
    /"([^(")"]+)":/g,
    '$1:'
  )})
  }`;
}
